import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Loader } from '../../components/Loader';
import { EVO } from '../../EVO';

export const O = props => {
    const [loading, setLoading] = useState(true);
    const [unsubscribed, setUnsubscribed] = useState(false);

    useEffect(() => {
        var id = EVO.getParamsId(props);
        if (!id) {
            EVO.alert('Invalid link. Please try again');
            setLoading(false);
            return;
        }

        EVO.post('/api/optout/email', { patientGuid: id }, { allowAnon: true }).then(r => {
            setUnsubscribed(true);
            setLoading(false);
        }).catch(e => {
            setLoading(false);
        });
    }, []);

    return <Loader loading={loading}>
        {unsubscribed ? <div>Successfully unsubscribed!</div> : <div></div>}
    </Loader>;
};

export const EmailOptout = withRouter(O);


// WEBPACK FOOTER //
// ./src/pages/Optout/Email.js